import React from 'react';
import PropTypes from 'prop-types';
import linkUtils from 'src/utils/linkUtils';
import { trackFootfallEvent } from 'src/utils/footfall';
import footfallEventTypes from 'src/constants/footfallEventTypes';
import Card from 'src/components/card';

const CommunityHomePromoImage = ({ widget }) => {
  const imageUrl = linkUtils.generatePromoImageLink(widget.imageHash);
  const linkUrl = linkUtils.prepLink(widget.url);
  return (
    <Card>
      <a
        aria-label="community promotion"
        className="campaign-image"
        href={linkUrl}
        style={{ backgroundImage: `url("${imageUrl}")` }}
        target="_blank"
        title="community promotion"
        onClick={() => {
          trackFootfallEvent(footfallEventTypes.CLICKED, {
            clickType: 'community-promo-image',
            clickMetadata: { section: 'community-side-bar' },
          });
        }}
      />
    </Card>
  );
};

CommunityHomePromoImage.propTypes = {
  widget: PropTypes.object.isRequired,
};

export default CommunityHomePromoImage;
